// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9dc7f240","455":"cece2e66","977":"fb3a4cc0"}[chunkId] + ".chunk.js";
};